import { render, staticRenderFns } from "./HardwareShopDetails.vue?vue&type=template&id=183f7bdd&scoped=true&"
import script from "./HardwareShopDetails.vue?vue&type=script&lang=js&"
export * from "./HardwareShopDetails.vue?vue&type=script&lang=js&"
import style0 from "./HardwareShopDetails.vue?vue&type=style&index=0&id=183f7bdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f7bdd",
  null
  
)

/* custom blocks */
import block0 from "./HardwareShopDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports